export const FETCH_LOGIN_INIT = 'FETCH_LOGIN_INIT';
export const FETCH_LOGIN_SUCCESS = 'FETCH_LOGIN_SUCCESS';
export const FETCH_LOGIN_FAILURE = 'FETCH_LOGIN_FAILURE';
export const FETCH_RECOVERY_INIT = 'FETCH_RECOVERY_INIT';
export const FETCH_RECOVERY_SUCCESS = 'FETCH_RECOVERY_SUCCESS';
export const FETCH_RECOVERY_FAILURE = 'FETCH_RECOVERY_FAILURE';
export const FETCH_CLEAN_ERRORS = 'FETCH_CLEAN_ERRORS';
